const translations = {
  'zh-TW': {
    title: 'TPES 人才測評',
    description: '請填寫以下信息後點擊下一步',
    name: '姓名',
    email: '電子郵件',
    phone: '電話',
    birthYear: '出生年',
    gender: '性別',
    male: '男',
    female: '女',
    next: '下一步',
    pleaseInput: '請輸入',
    forExample: '例如',
    optional: '選填',
    nameRequired: '姓名為必填項',
    emailRequired: '無效的郵箱',
    phoneRequired: '電話為必填項',
    birthYearRequired: '出生年為必填項',
    genderRequired: '請選擇性別',

    // AssessmentIntro
    assessmentTitle: '測評指引(請務必詳細閱讀)',
    networkNote: '請再三確認網路訊號正常，避免因網路中斷, 而使測評無法順利進行。',
    focusNote: '本測評是專業的性格測評, 需預留約15-30分鐘，不會被打擾的時間, 請靜下心來專心回答。',
    choiceNote: '每一個題目都有以下三個選項, 沒有好壞對錯，請看清楚題目敘述, 然後選擇一個符合您的選項。',
    startNote: '閱讀完後，點擊下方的「開始測評」按鈕進入正式測評頁面。',
    startButton: '開始測評',
    optionYes: { key: 'yes', title: '是 / 同意', description: '大部分同意或完全同意 題目敘述。' },
    optionMaybe: { key: 'maybe', title: '偶爾 / 部分同意', description: '一部分同意但另一部分不同意 題目敘述, 或是覺得題目敘述前後矛盾。' },
    optionNo: { key: 'no', title: '否 / 不同意', description: '較不同意或完全不同意 題目敘述。' },
    resumeDialog: {
      message: '檢測到已有部分作答記錄。點擊「接續答題」繼續之前的測評，點擊「重新開始」重新開始測評。',
      continueButton: '接續答題',
      restartButton: '重新開始'
    },

    // AssessmentQuiz
    quizTitle: '測評問卷',
    questionPrefix: '題目',
    ofTotal: '共',
    optionYes2: '是 (完全同意)',
    optionMaybe2: '偶尔 (部分同意)',
    optionNo2: '否 (不同意)',
    previousButton: '上一題',
    submitButton: '完成送出',

    // ResultSubmission
    resultSubmission: {
      title: '請注意！務必按下「提交測評結果」按鈕，並確認「測評結果已成功提交」，方可關閉測評頁面。',
      button: '提交測評結果',
      buttonLoading: '提交中...',
      success: '測評結果已成功提交！',
      fail: '提交失敗，請稍後再試。',
      evaluationCode: '測評唯一碼',
      copy: '複製',
      copied: '📋 已複製',
    },
    errorMessages: {
      UNAUTHORIZED_ACCESS: '未授權的存取',
      MISSING_PARAMETERS: '缺少參數或格式錯誤',
      INVALID_CREATED_AT: 'created_at 格式錯誤',
      EVAL_ALREADY_EXISTS: '該測評紀錄已存在，無法再次填寫',
      EVAL_NOT_FOUND: '找不到指定的測評紀錄',
      USER_NOT_FOUND: 'useruuid 無效，找不到使用者',
      SCORE_ERROR: '計分錯誤',
      INTERNAL_SERVER_ERROR: '伺服器發生錯誤，請稍後再試'
    },   
  },

  'zh-CN': {
    title: 'TPES 人才测评',
    description: '请填写以下信息后点击下一步',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    birthYear: '出生年',
    gender: '性别',
    male: '男',
    female: '女',
    next: '下一步',
    pleaseInput: '请输入',
    forExample: '例如',
    optional: '选填',
    nameRequired: '姓名为必填项',
    emailRequired: '无效的邮箱',
    phoneRequired: '电话为必填项',
    birthYearRequired: '出生年为必填项',
    genderRequired: '请选择性别',

    assessmentTitle: '测评指引(请务必详细阅读)',
    networkNote: '请再三确认网络讯号正常，避免因网络中断, 而使测评无法顺利进行。',
    focusNote: '本测评是专业的性格测评, 需预留约15-30分钟，不会被打扰的时间, 请静下心来专心回答。',
    choiceNote: '每一个题目都有以下三个选项, 没有好坏对错，请看清楚题目叙述, 然后选择一个符合您的选项。',
    startNote: '阅读完后，点击下方的“开始测评”按钮进入正式测评页面。',
    startButton: '开始测评',
    optionYes: { key: 'yes', title: '是 / 同意', description: '大部分同意或完全同意 题目叙述。' },
    optionMaybe: { key: 'maybe', title: '偶尔 / 部分同意', description: '一部分同意但另一部分不同意 题目叙述, 或是觉得题目叙述前后矛盾。' },
    optionNo: { key: 'no', title: '否 / 不同意', description: '较不同意或完全不同意 题目叙述。' },
    resumeDialog: {
      message: '检测到已有部分作答记录。点击「接续答题」继续之前的测评，点击「重新开始」重新开始测评。',
      continueButton: '接续答题',
      restartButton: '重新开始'
    },

    quizTitle: '测评问卷',
    questionPrefix: '题目',
    ofTotal: '共',
    optionYes2: '是 (完全同意)',
    optionMaybe2: '偶尔 (部分同意)',
    optionNo2: '否 (不同意)',
    previousButton: '上一题',
    submitButton: '完成送出',

    resultSubmission: {
      title: '请注意！务必点击“提交测评结果”按钮，并确认“测评结果已成功提交”后再关闭页面。',
      button: '提交测评结果',
      buttonLoading: '提交中...',
      success: '测评结果已成功提交！',
      fail: '提交失败，请稍后再试。',
      evaluationCode: '测评唯一码',
      copy: '复制',
      copied: '📋 已复制',
    },  
    errorMessages: {
      UNAUTHORIZED_ACCESS: '未授权的访问',
      MISSING_PARAMETERS: '缺少参数或格式错误',
      INVALID_CREATED_AT: 'created_at 格式错误',
      EVAL_ALREADY_EXISTS: '该测评记录已存在，无法再次提交',
      EVAL_NOT_FOUND: '找不到指定的测评记录',
      USER_NOT_FOUND: 'useruuid 无效，找不到用户',
      SCORE_ERROR: '计分错误',
      INTERNAL_SERVER_ERROR: '服务器发生错误，请稍后再试'
    },    
  },

  vi: {
    title: 'Đánh giá nhân tài TPES',
    description: 'Vui lòng điền thông tin sau đây và nhấp vào "Tiếp theo"',
    name: 'Họ tên',
    email: 'Hộp thư điện tử',
    phone: 'Số điện thoại',
    birthYear: 'Năm sinh',
    gender: 'Giới tính',
    male: 'Nam',
    female: 'Nữ',
    next: 'Tiếp theo',
    pleaseInput: 'Vui lòng nhập',
    forExample: 'Ví dụ',
    optional: 'Không bắt buộc',
    nameRequired: 'Họ tên là trường bắt buộc',
    emailRequired: 'Email không hợp lệ',
    phoneRequired: 'Số điện thoại là trường bắt buộc',
    birthYearRequired: 'Năm sinh là trường bắt buộc',
    genderRequired: 'Vui lòng chọn giới tính',
    // assessmentTitle: 'Hướng dẫn đánh giá',
    // networkNote: 'Vui lòng đảm bảo kết nối mạng ổn định.',
    // focusNote: 'Dành 15-30 phút, tập trung trả lời.',
    // choiceNote: 'Mỗi câu hỏi không có đúng sai, hãy chọn theo trực giác.',
    // startNote: 'Đọc xong, nhấn “Bắt đầu đánh giá” để tiếp tục.',
    // startButton: 'Bắt đầu đánh giá',
    // optionYes: { key: 'yes', title: 'Có / Đồng ý', description: 'Đồng ý phần lớn hoặc hoàn toàn.' },
    // optionMaybe: { key: 'maybe', title: 'Thỉnh thoảng / Phần nào đồng ý', description: 'Đồng ý một phần nhưng còn do dự.' },
    // optionNo: { key: 'no', title: 'Không / Không đồng ý', description: 'Không đồng ý phần lớn hoặc hoàn toàn.' },
    assessmentTitle: 'Hướng dẫn làm bài đánh giá (vui lòng đọc kỹ)',
    networkNote: 'Vui lòng kiểm tra thật kỹ tín hiệu mạng để đảm bảo ổn định, tránh gián đoạn khiến bài đánh giá không thể tiếp tục.',
    focusNote: 'Đây là bài đánh giá tính cách chuyên nghiệp, cần chuẩn bị khoảng 15–30 phút trong không gian yên tĩnh, không bị làm phiền, và tập trung trả lời.',
    choiceNote: 'Mỗi câu hỏi có ba lựa chọn, không có đúng hay sai. Hãy đọc kỹ mô tả và chọn phương án phù hợp nhất với bạn.',
    startNote: 'Sau khi đọc xong, nhấn “Bắt đầu đánh giá” để vào trang chính thức.',
    startButton: 'Bắt đầu đánh giá',
    optionYes: { key: 'yes', title: 'Có / Đồng ý', description: 'Phần lớn đồng ý hoặc hoàn toàn đồng ý với mô tả của câu hỏi.' },
    optionMaybe: { key: 'maybe', title: 'Thỉnh thoảng / Một phần đồng ý', description: 'Một phần đồng ý nhưng một phần không đồng ý, hoặc cảm thấy mô tả của câu hỏi có sự mâu thuẫn.' },
    optionNo: { key: 'no', title: 'Không / Không đồng ý', description: 'Ít đồng ý hoặc hoàn toàn không đồng ý với mô tả của câu hỏi.' },
    resumeDialog: {
      message: 'Phát hiện đã có một phần câu trả lời được lưu. Nhấn “Tiếp tục làm bài” để tiếp tục bài đánh giá trước đó hoặc nhấn “Bắt đầu lại” để làm lại từ đầu.',
      continueButton: 'Tiếp tục làm bài',
      restartButton: 'Bắt đầu lại'
    },

    quizTitle: 'Bài Đánh Giá',
    questionPrefix: 'Câu hỏi',
    ofTotal: 'trong số',
    optionYes2: 'Đúng',
    optionMaybe2: 'Thỉnh thoảng',
    optionNo2: 'Sai',
    previousButton: 'Quay lại câu trước',
    submitButton: 'Hoàn thành và gửi đi',

    resultSubmission: {
      title: 'Lưu ý! Hãy nhấn nút "Gửi kết quả đánh giá" và xác nhận "Kết quả đánh giá đã được gửi thành công" trước khi đóng trang đánh giá.',
      button: 'Gửi kết quả đánh giá',
      buttonLoading: 'Đang gửi...',
      success: 'Kết quả đánh giá đã được gửi thành công!',
      fail: 'Gửi thất bại, vui lòng thử lại sau.',
      evaluationCode: 'Mã đánh giá duy nhất',
      copy: 'Sao chép',
      copied: '📋 Đã sao chép',
    },
    errorMessages: {
      UNAUTHORIZED_ACCESS: 'Truy cập không được phép',
      MISSING_PARAMETERS: 'Thiếu tham số hoặc định dạng không hợp lệ',
      INVALID_CREATED_AT: 'Định dạng created_at không hợp lệ',
      EVAL_ALREADY_EXISTS: 'Bản đánh giá đã tồn tại, không thể gửi lại',
      EVAL_NOT_FOUND: 'Không tìm thấy bản đánh giá được chỉ định',
      USER_NOT_FOUND: 'useruuid không hợp lệ, không tìm thấy người dùng',
      SCORE_ERROR: 'Lỗi tính điểm',
      INTERNAL_SERVER_ERROR: 'Máy chủ xảy ra lỗi, vui lòng thử lại sau'
    },    
  },

  en: {
    title: 'TPES Talent Assessment',
    description: 'Please fill out the information below and click "Next"',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    birthYear: 'Birth Year',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    next: 'Next',
    pleaseInput: 'Please input',
    forExample: 'For example',
    optional: 'Optional',
    nameRequired: 'Name is required',
    emailRequired: 'Invalid email address',
    phoneRequired: 'Phone is required',
    birthYearRequired: 'Birth year is required',
    genderRequired: 'Please select gender',

    assessmentTitle: 'Assessment Guide',
    networkNote: 'Ensure a stable internet connection.',
    focusNote: 'Reserve 15-30 minutes and answer calmly.',
    choiceNote: 'No right or wrong answers, choose instinctively.',
    startNote: 'After reading, click “Start Assessment” to proceed.',
    startButton: 'Start Assessment',
    optionYes: { key: 'yes', title: 'Yes / Agree', description: 'Mostly or fully agree.' },
    optionMaybe: { key: 'maybe', title: 'Sometimes / Partially Agree', description: 'Partially agree with some reservations.' },
    optionNo: { key: 'no', title: 'No / Disagree', description: 'Mostly or fully disagree.' },
    resumeDialog: {
      message: 'We detected partial answers saved. Click “Continue” to resume your previous assessment, or click “Restart” to start over.',
      continueButton: 'Continue',
      restartButton: 'Restart'
    },

    quizTitle: 'Assessment Quiz',
    questionPrefix: 'Question',
    ofTotal: 'of',
    optionYes2: 'Yes',
    optionMaybe2: 'Maybe',
    optionNo2: 'No',
    previousButton: 'Previous',
    submitButton: 'Submit',

    resultSubmission: {
      title: 'Please make sure to click "Submit Assessment Result" and confirm "Submission Successful" before closing this page.',
      button: 'Submit Assessment Result',
      buttonLoading: 'Submitting...',
      success: 'Assessment result submitted successfully!',
      fail: 'Submission failed, please try again later.',
      evaluationCode: 'Evaluation UUID',
      copy: 'Copy',
      copied: '📋 Copied',
    },
    errorMessages: {
      UNAUTHORIZED_ACCESS: 'Unauthorized access',
      MISSING_PARAMETERS: 'Missing parameters or invalid format',
      INVALID_CREATED_AT: 'Invalid created_at format',
      EVAL_ALREADY_EXISTS: 'The evaluation record already exists and cannot be submitted again',
      EVAL_NOT_FOUND: 'Specified evaluation record not found',
      USER_NOT_FOUND: 'Invalid useruuid, user not found',
      SCORE_ERROR: 'Scoring error',
      INTERNAL_SERVER_ERROR: 'Server error, please try again later'
    },    
  },
};

export default translations;
